document.addEventListener("click", (e) => {
const imgBlock = document.querySelector(".tangent-quiz-img-block");
  if (e.target.closest(".tangent_69b3cbd18ccc13a3861ae751_survey_next_button_custom")) {
    console.log("event triggered");

    if (imgBlock) {
      imgBlock.style.display = "block";
    }
  }
  if(e.target.closest(".tangent_backbtn_custom")){
    if (imgBlock) {
      imgBlock.style.display = "none";
    }
  }
});